import type { GQL_ID } from '@@partner:types:graphql'
import type { CustomerInfo } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_CUSTOMERS_FIELDS } from '@@partner:graphql/shortcuts'

export interface CustomerInfoInput {
  id?: GQL_ID
  status?: number
  phone: string
  first_name?: string
  last_name?: string
  receipt_email?: string
}

export interface SaveCustomer {
  customerInfo: CustomerInfo
}
export interface SaveCustomerVariables {
  customerInfo: CustomerInfoInput
  upsert: boolean
}

export const GQL_MUTATION_SAVE_CUSTOMER = gql`
  mutation ($newData: CustomerInfoInput!, $upsert: Boolean!) {
    customerInfo: updateCustomer(newData: $newData, upsert: $upsert) {
      id
      phone
      first_name
      last_name
      receipt_email
      status
    }
  }
`

export const useMutateSaveCustomer = () =>
  useMutation<SaveCustomer, SaveCustomerVariables>(GQL_MUTATION_SAVE_CUSTOMER)
